export class LogoMockupModel {
    constructor() {
        this.url = "/images/no-image.png";
        this.positionLevel = 0;
        this.positionLevelName = "";
        this.brandMockup = "/images/no-image.png"
    }
}
